import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import FileSaver from 'file-saver';
import Service from '../services';
import Loader from '../../../../commons/loader';
import TimeFormatter from '../../../../commons/TimeFormatter';
import { PaginationTotal, DatePicker } from '../../../../commons/controls';
import NetworkEmptyState from '../../../../commons/networkemptystate';
import DataEmptyState from '../../../../commons/dataemptystate';
import Utility from '../Utility';
import NaptarModule from './NaptarModule';
import DayPickerHu from './DayPickerHu';
import isSameDay from 'date-fns/isSameDay';
import {
  ModalNaptar,
  ModalNaptarChoice,
  ModalNaptarDelete,
  ModalNaptarView,
  ModalFoglalas,
  ModalPartner
} from './Modals';
import RFForm from '../../../../components/Form/RFForm';
import RFField from '../../../../components/Form/RFField';
import ProgressButton from '../../../../commons/ProgressButton';

class Naptar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copySource: null,
      dolgozoFilterSelected: null,
      dolgozoOptions: [],
      email: false,
      foglalasNelkul: false,
      insert: true,
      ismetlodesCheck: false,
      ismetlodesOptions: [],
      ismetlodesSelected: null,
      loading: false,
      modalFoglalas: false,
      modalFoglalasDelete: false,
      modalMasolas: false,
      modalNaptar: false,
      modalNaptarChoice: false,
      modalNaptarTorles: false,
      modalNaptarView: false,
      modalPartner: false,
      naptarJSON: {},
      obj: {},
      orszagOptions: [],
      telefonTipusOptions: [],
      partnerobj: {},
      partnercsoportOptions: [],
      selectedDay: new Date(),
      selectedDays: [],
      szolgaltatasList: [],
      szolgaltatasModositObj: {},
      szolgaltatasok: [],
      szolgaltatasokJSON: [],
      szolgaltatasOptions: [],
      szolgaltatasSelected: null,
      szolgaltatasViewList: [],
      teremFilterSelected: null,
      teremOptions: [],
      teremOptionsJSON: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: 'HIDD',
      kategoriaFilterSelected: '',
      kategoriaOptions: null,
      kategoriaJSON: null,
      helyszinId: null,

      lekerdezesButtonLoading: false,
      saveButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    if (this.hasRoleKarb()) {
      this.getIsmetlodesEnum();
    }
    this.getTelefonEnum();
    this.updateFilters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '1' && this.props.activeTab === '1') {
      this.updateFilters();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['IDOPONT'], true);
  }

  convertKategoriaJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.kategoriaJSON);
    for (let kategoria of array) {
      let valueObj = {}
      valueObj.kategoriaid = kategoria.id;
      valueObj.helyszinid = kategoria.helyszinid;
      mezok.push(<option value={JSON.stringify(valueObj)}>{kategoria.nev}</option>);
    }
    this.setState({ kategoriaOptions: mezok });
  }

  updateKategoriaFilters = () => {
    Service.listKategoriaByRole((err, res) => {
      if (!err) {
        this.setState({ kategoriaJSON: res[0] }, () => {
          this.convertKategoriaJsonToOptions();
        });
      }
    });
  }

  convertSzolgaltatasJsonToOptions = (editCallbackNeeded) => {
    let mezok = [];
    let array = Array.from(this.state.szolgaltatasokJSON);
    array.sort((a, b) => { return a.nev.localeCompare(b.nev) });
    for (let szolgaltatas of array) {
      mezok.push(<option value={szolgaltatas.id}>{szolgaltatas.nev}</option>);
    }
    this.setState({ szolgaltatasOptions: mezok }, () => {
      if (editCallbackNeeded)
        this.naptarEditClickCallback();
    });
  }

  getIsmetlodesEnum = () => {
    Service.listIsmetlodesEnum((err, res) => {
      if (!err) {
        let ismetlodesOptions = [];
        for (const obj of res[0]) {
          ismetlodesOptions.push(<option key={obj.name} value={obj.name}>{obj.nev}</option>)
        }
        this.setState({ ismetlodesOptions });
      }
    });
  }

  getTelefonEnum = () => {
    Service.listTelefonEnum((err, res) => {
      if (!err) {
        let telefontipusOptions = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);

        this.setState({
          orszagOptions: res[0][0],
          telefonTipusOptions: telefontipusOptions,
        });
      }
    });
  }

  updateFilters = () => {
    this.updateTeremFilter();
    this.updateKategoriaFilters();
  }

  updateTeremFilter = () => {
    Service.listTerem((err, res) => {
      if (!err) {
        let teremOptions = [];
        for (let terem of res[0]) {
          let option = <option value={terem.id}>{terem.nev + ' (' + terem.azonosito + ')'}</option>
          Utility.insertByOrder(teremOptions, option);
        }
        this.setState({ teremOptions, teremOptionsJSON: res[0] });
      }
    });
  }

  // editCallbackNeeded esetén naptarEditClickCallback lesz meghívva
  updateSzolgaltatasOptions = (dolgozoid, editCallbackNeeded) => {
    this.setState({ dolgozoFilterSelected: dolgozoid });
    Service.listSzolgaltatas(true, dolgozoid, (err, res) => {
      if (!err) {
        this.setState({ szolgaltatasokJSON: res[0], szolgaltatasList: [], szolgaltatasSelected: null }, () => {
          this.convertSzolgaltatasJsonToOptions(editCallbackNeeded);
        });
      }
    });
  }

  updateIsmetlodesOption = (value) => {
    this.setState({ ismetlodesSelected: value });
  }

  updateTable = (buttonPress) => {
    const {
      foglalasNelkul,
      teremFilterSelected,
      selectedDay
    } = this.state;
    if (!teremFilterSelected) {
      if (buttonPress != true)
        this.updateTeremFilter();
      else
        this.props.globals.addError('Kereséshez terem választása kötelező!');
    } else {
      let date = selectedDay;
      // Éjfélre ugrás
      date.setHours(0);
      this.setState({ tableStatus: 'LOAD', lekerdezesButtonLoading: true }, () => {
        Service.listNaptarNezet(date, teremFilterSelected, foglalasNelkul, (err, res) => {
          if (!err) {
            const status = !res[0].sorok || res[0].sorok.length == 0 ? 'DATA' : 'TABL';
            this.setState({ naptarJSON: res[0], tableStatus: status, lekerdezesButtonLoading: false });
          } else {
            this.setState({ tableStatus: 'NETW', lekerdezesButtonLoading: false });
          }
        });
      });
    }
  }

  toggleIsmetlodesCheck = () => {
    this.setState((prevState) => { return ({ ismetlodesCheck: !prevState.ismetlodesCheck }); });
  }

  toggleNaptarView = () => {
    this.setState((prevState) => { return ({ modalNaptarView: !prevState.modalNaptarView }); });
  }

  toggleNaptar = (obj) => {
    this.setState((prevState) => { return ({ modalNaptar: !prevState.modalNaptar, date: null, ...obj, ismetlodesCheck: false, ismetlodesSelected: null }); });
  }

  toggleMasolas = () => {
    this.setState((prevState) => { return ({ modalMasolas: !prevState.modalMasolas, selectedDays: [], copySource: null }); });
  }

  toggleNaptarTorles = () => {
    this.setState((prevState) => { return ({ modalNaptarTorles: !prevState.modalNaptarTorles }); });
  }

  toggleNaptarChoice = () => {
    this.setState((prevState) => { return ({ modalNaptarChoice: !prevState.modalNaptarChoice }) });
  }

  toggleFoglalas = (edit) => {
    this.setState((prevState) => { return ({ modalFoglalas: !prevState.modalFoglalas }) });
    if (!edit)
      this.setState({ partnerobj: {} });
  }

  toggleFoglalasDelete = () => {
    this.setState((prevState) => { return ({ modalFoglalasDelete: !prevState.modalFoglalasDelete }) });
  }

  toggleFoglalasCheckbox = () => {
    this.setState((prevState) => { return ({ foglalasNelkul: !prevState.foglalasNelkul }) });
  }

  togglePartner = () => {
    this.setState((prevState) => { return ({ modalPartner: !prevState.modalPartner }) });
  }

  // Azért van így megcsinálva, hogy a mező hiánya esetén ne írja át null-ra a setState
  handleSzolgaltatasSetState = (obj) => {
    let obj2 = {};
    if (obj.hasOwnProperty('elementSelected'))
      obj2.szolgaltatasSelected = obj.elementSelected
    if (obj.hasOwnProperty('list'))
      obj2.szolgaltatasList = obj.list;
    if (obj.hasOwnProperty('options'))
      obj2.szolgaltatasOptions = obj.options;
    this.setState(obj2);
  }

  handleForgalomSetState = (obj, callback) => {
    let obj2 = {};
    if (obj.hasOwnProperty('email'))
      obj2.email = obj.email;
    this.setState(obj2, callback);
  }

  handleTeremSelect = (event, value) => {
    this.setState({ teremFilterSelected: value });
    Service.listDolgozoByTerem(value, (err, res) => {
      if (!err) {
        let dolgozoOptions = [];
        for (const dolgozo of res[0]) {
          let option = <option value={dolgozo.id}>{dolgozo.nev}</option>;
          Utility.insertByOrder(dolgozoOptions, option);
        }

        let helyszinId = this.state.teremOptionsJSON.find(x => x.id === parseInt(value, 10)).helyszinid;

        this.setState({ dolgozoOptions, helyszinId });
      }
    });
  }

  handleDaySelect = (selectedDay) => {
    this.setState({ selectedDay });
  }

  handleMasolasDaySelect = (day, { selected }) => {
    const { selectedDays } = this.state;
    if (selected) {
      const selectedIndex = selectedDays.findIndex(selectedDay =>
        isSameDay(selectedDay, day)
      );
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
    this.setState({ selectedDays });
  }

  handleNaptarViewClick = () => {
    let szolgaltatasViewList = [];
    for (let szolgaltatas of this.state.obj.szolgaltatasselected) {
      Utility.insertByOrder(szolgaltatasViewList, <div>{szolgaltatas.nev}<br /></div>);
    }
    this.setState({ szolgaltatasViewList });
    this.toggleNaptarView();
  }

  handleNaptarAddClick = (obj) => {
    this.setState({ obj, insert: true, szolgaltatasSelected: null, szolgaltatasList: [], dolgozoFilterSelected: null });
    this.toggleNaptar();
  }

  handleNapMasolasClick = () => {
    this.toggleMasolas();
  }

  handleNaptarChoiceClick = (foglalasObj) => {
    this.setState({ loading: true });
    Service.getNaptar(foglalasObj.id, (err, res) => {
      if (!err) {
        let obj = res[0];
        obj.date = new Date(obj.idokezdet);
        obj.kezdet = new Date(obj.idokezdet);
        obj.vege = new Date(obj.idovege);
        obj.fogkezdet = foglalasObj.fogkezdet;
        this.setState({ obj, loading: false, dolgozoFilterSelected: res[0].dolgozoid });
        this.toggleNaptarChoice();
      }
    });
  }

  naptarEditClickCallback = () => {
    let szolgaltatasok = this.state.obj.szolgaltatasselected;
    let szolgaltatasListAlt = [];
    for (let option of this.state.szolgaltatasOptions) {
      for (let szolgaltatas of szolgaltatasok) {
        if (szolgaltatas.id == option.props.value) {
          szolgaltatasListAlt.push(
            <option value={option.props.value}>
              {option.props.children}
            </option>
          );
        }
      }
    }
    this.toggleNaptar();
    this.setState({ insert: false, szolgaltatasList: szolgaltatasListAlt, szolgaltatasSelected: null });
  }

  handleNaptarEditClick = () => {
    this.updateSzolgaltatasOptions(this.state.obj.dolgozoid, true);
  }

  handleNaptarDeleteClick = () => {
    this.toggleNaptarTorles();
  }

  handleFoglalasAddClick = () => {
    const {
      szolgaltatasselected,
    } = this.state.obj;
    let szolgaltatasOptions = [];
    for (let szolgaltatas of szolgaltatasselected)
      szolgaltatasOptions.push(<option value={szolgaltatas.id}>{szolgaltatas.nev}</option>);
    let obj = {
      ...this.state.obj,
      szolgaltatasOptions
    };

    this.setState({ obj, insert: true, kategoriaFilterSelected: null });
    this.toggleFoglalas();
  }

  handleFoglalasEditClick = (foglalasid) => {
    Service.getFoglalas(foglalasid, (err, res) => {
      if (!err) {
        let obj = res[0];
        let szolgaltatasOptions = [];
        for (let szolgaltatas of obj.szolgaltatasok)
          szolgaltatasOptions.push(<option value={szolgaltatas.id}>{szolgaltatas.nev}</option>);
        obj.szolgaltatasOptions = szolgaltatasOptions;

        obj.date = new Date(obj.kezdet);
        obj.fogkezdet = new Date(obj.kezdet);

        let partnerobj = obj.partner;
        let telszam;
        if (partnerobj.telefon && partnerobj.telefon.length > 0)
          telszam = partnerobj.telefon[0];
        partnerobj.telefon = this.dataOrEmptyString(telszam);
        let szul = '';
        if (partnerobj.szulido) {
          // LocalDate JSON-ben tömb, ezért van így vissza formázva
          for (const string of partnerobj.szulido)
            szul += string + '. ';
        }
        partnerobj.szulido = szul;

        this.setState({ obj, partnerobj, insert: false });
        this.toggleFoglalas(true);
      }
    });
  }

  handlePartnerModalClick = () => {
    Service.getPartnerParameters(this.state.helyszinId, (err, res) => {
      if (!err) {
        let partnerobj = this.state.partnerobj;
        partnerobj.partnercsoportid = res[0].partnercsoportid;
        // partnerobj.jogAlapId = res[0].gdprjogalapid;
        // partnerobj.cegadatId = res[0].cegadatid;
        partnerobj.vezeteknev = '';
        partnerobj.keresztnev = '';

        let hozzajarulasok = [];
        hozzajarulasok.push({
          // jogalapid: res[0].gdprjogalapid,
          jogalap: res[0].jogalapnev,
          // cegadatid: res[0].cegadatid,
          cegadat: res[0].cegadatnev,
          hozzajarul: false,
        });
        partnerobj.hozzajarulas = hozzajarulasok;

        this.setState({ partnerobj });
        // let teremid = this.state.obj.teremid;
        // Service.getTeremByIds([teremid], (err, res) => {
        //   if (!err) {
        //     let helyszinid = res[0][teremid].helyszinid;
        //     Service.getHelyszinByIds([helyszinid], (err, res) => {
        //       if (!err) {
        //         let partnerobj = this.state.partnerobj;
        //         partnerobj.cegadatId = res[0][helyszinid].cegadatid;
        //       }
        //     });
        //   }
        // });
      }
    });
    Service.initPartnerCsop((err, res) => {
      if (!err) {
        let partnercsoportOptions = res[0].map(e => (
          <option key={e.id} value={e.id}>
            {e.nev}
          </option>
        ));
        this.setState({ partnercsoportOptions });
      }
    });
    this.togglePartner();
  }

  dataOrEmptyString = (string) => {
    if (string)
      return string;
    return '';
  }

  insertStateFieldsIntoObject = (naptarObj) => {
    const {
      date,
      kezdet,
      vege
    } = this.state.obj;
    if (!date) {
      this.props.globals.addError("Dátum megadása kötelező!");
    } else if (!kezdet) {
      this.props.globals.addError("A kezdete időpont megadása kötelező!");
    } else if (!vege) {
      this.props.globals.addError("A vége időpont megadása kötelező!");
    } else {
      let idokezdet = new Date(date);
      let idovege = new Date(date);
      idokezdet.setHours(kezdet.getHours());
      idokezdet.setMinutes(kezdet.getMinutes());
      idovege.setHours(vege.getHours());
      idovege.setMinutes(vege.getMinutes());
      // Ha a végénél éjfél van kiválasztva, akkor a következő napra át van léptetve a vége
      if (vege.getHours() == 0 && vege.getMinutes() == 0) {
        idovege.setDate(idovege.getDate() + 1);
      }
      naptarObj.idokezdet = idokezdet;
      naptarObj.idovege = idovege;
      naptarObj.szolgaltatasidk = this.state.szolgaltatasList.map((option) => {
        return option.props.value;
      });
      return true;
    }
  }

  addNaptar = (event, naptarObj) => {
    let hiba = false;
    let { ismetlodesvege } = this.state.obj;
    if (this.state.ismetlodesCheck) {
      if (!ismetlodesvege) {
        this.props.globals.addError("Ismétlődés végének megadása kötelező!");
        hiba = true;
      }
      naptarObj.szombat = naptarObj.szombat || false;
      naptarObj.vasarnap = naptarObj.vasarnap || false;
      naptarObj.ismetlodesvege = ismetlodesvege;
    }
    if (!hiba && this.insertStateFieldsIntoObject(naptarObj)) {
      this.setState({ saveButtonLoading: true });
      Service.addNaptar(naptarObj, (err) => {
        if (!err) {
          this.toggleNaptar();
          this.updateTable();
          this.props.globals.addSuccess('Intervallum hozzáadva!');
        }
        this.setState({ saveButtonLoading: false });
      });
    }
  }

  editNaptar = (event, naptarObj) => {
    naptarObj.id = this.state.obj.id;
    if (this.insertStateFieldsIntoObject(naptarObj)) {
      this.setState({ saveButtonLoading: true });
      Service.editNaptar(naptarObj, (err) => {
        if (!err) {
          this.updateTable();
          this.toggleNaptar();
          this.props.globals.addSuccess('Intervallum módosítva!');
        }
        this.setState({ saveButtonLoading: false });
      });
    }
  }

  deleteNaptar = () => {
    const {
      obj,
    } = this.state;
    this.toggleNaptarTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteNaptar(obj && obj.id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Időpont törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  copyDay = () => {
    const {
      copySource,
      selectedDays,
      teremFilterSelected,
    } = this.state;
    let obj = {
      cel: selectedDays,
      forras: copySource,
      teremid: teremFilterSelected,
    };
    if (!selectedDays.length) {
      this.props.globals.addError('Legalább egy cél nap kiválasztása kötelező!')
    } else {
      this.setState({ saveButtonLoading: true });
      Service.copyDay(obj, (err, res) => {
        if (!err) {
          if (res[0] && res[0].length) {
            let uzenet;
            if (res[0].length > 1) {
              uzenet = 'A következő napok nem voltak szabadok a szükséges időkben: ';
              uzenet += res[0][0];
              for (let i = 1; i < res[0].length; i++) {
                const date = res[0][i];
                uzenet += ', ' + date;
              }
            } else {
              uzenet = 'A következő nap nem volt szabad a szükséges időkben: ' + res[0][0];
            }
            this.props.globals.addWarningWithPosAndDismiss(uzenet, 'tc', 0);
          } else {
            this.props.globals.addSuccess('Sikeres másolás!');
          }
          if (this.state.teremFilterSelected)
            this.updateTable();
          this.toggleMasolas();
        }
        this.setState({ saveButtonLoading: false });
      });
    }
  }

  addFoglalas = (event, foglalasObj) => {
    let kezdet = new Date();
    const {
      date,
      fogkezdet,
      partnerid
    } = this.state.obj;
    foglalasObj.partnerid = partnerid;
    kezdet.setFullYear(date.getFullYear());
    kezdet.setMonth(date.getMonth());
    kezdet.setDate(date.getDate());
    kezdet.setHours(fogkezdet.getHours());
    kezdet.setMinutes(fogkezdet.getMinutes());
    foglalasObj.kezdet = kezdet;
    foglalasObj.naptarid = this.state.obj.id;
    if (this.state.kategoriaFilterSelected) {
      const selected = JSON.parse(this.state.kategoriaFilterSelected);
      foglalasObj.helyszinid = selected.helyszinid;
      foglalasObj.kategoriaid = selected.kategoriaid;
    }
    this.setState({ saveButtonLoading: true });
    Service.addFoglalas(foglalasObj, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás hozzáadva!');
        this.toggleFoglalas();
        this.updateTable();
      }
      this.setState({ saveButtonLoading: false });
    });
  }

  editFoglalas = (event, foglalasObj) => {
    let kezdet = new Date();
    const {
      date,
      fogkezdet,
      id,
      partner,
      partnerid
    } = this.state.obj;
    let pid;
    if (partnerid == null)
      pid = partner.id;
    else
      pid = partnerid;
    foglalasObj.id = id;
    foglalasObj.partnerid = pid;
    kezdet.setFullYear(date.getFullYear());
    kezdet.setMonth(date.getMonth());
    kezdet.setDate(date.getDate());
    kezdet.setHours(fogkezdet.getHours());
    kezdet.setMinutes(fogkezdet.getMinutes());
    foglalasObj.kezdet = kezdet;
    this.setState({ saveButtonLoading: true });
    Service.editFoglalas(foglalasObj, this.state.email, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás módosítva!');
        this.toggleFoglalas();
        this.updateTable();
      }
      this.setState({ saveButtonLoading: false });
    });
  }

  deleteFoglalas = (event, obj) => {
    this.setState({ deleteButtonLoading: true });
    Service.deleteFoglalas(this.state.obj.id, obj.reason, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás törölve!');
        this.toggleFoglalas();
        this.toggleFoglalasDelete();
        this.updateTable();
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  addPartner = (event, obj) => {
    console.log(obj);
    console.log(this.state.partnerobj);
    
    if (this.state.partnerobj.hozzajarulas && this.state.partnerobj.hozzajarulas.length && this.state.partnerobj.hozzajarulas.some(x => !x.hozzajarul)) {
      this.props.globals.addError('A partner csak a GDPR hozzájárulás elfogadását követően rögzíthető!');
      return;
    }
    // if (obj.tel)
    //   obj.telefon = obj.tel;
    obj = {
      // ...this.state.partnerobj,
      // ...obj,
      helyszinId: this.state.helyszinId,
      partnercsoportId: this.state.partnerobj.partnercsoportid,
      titulus: obj.titulus,
      vezeteknev: this.state.partnerobj.vezeteknev,
      keresztnev: this.state.partnerobj.keresztnev,
      szuletesnap: this.state.partnerobj.szuletesnap,
      email: obj.email,
      telefontipus: obj.telefontipus,
      orszaghivo: this.state.orszaghivo && this.state.orszaghivo.name,
      telefon: obj.tel,
    };
    console.log('add');
    console.log(obj);


    this.setState({ saveButtonLoading: true });
    Service.insertPartnerBase(obj, (err, res) => {
      if (!err) {
        this.togglePartner();
        Service.getPartner(res[0].ptId, (err, res) => {
          if (!err) {
            let obj = this.state.obj;
            obj.partnerid = res[0].id;
            let partnerobj = this.state.partnerobj;
            let telefon = null;
            if (res[0].telefon && res[0].telefon.length > 0)
              telefon = res[0].telefon;
            partnerobj = {
              ...partnerobj,
              szulido: res[0].szulido,
              email: res[0].email,
              nev: res[0].nev,
              telefon: this.dataOrEmptyString(telefon),
            };
            this.setState({ obj, partnerobj });
          }
          this.setState({ saveButtonLoading: false });
        });
      }else{
        this.setState({ saveButtonLoading: false });
      }
    });
  }

  loadSzolgaltatasElement = (obj) => {
    this.setState({ szolgaltatasSelected: obj });
  }

  handlePartnerChange = (selectObj) => {
    let obj = this.state.obj;
    if (!selectObj) {
      obj.partnerid = null;
      let partnerobj = { szulido: '', email: '', nev: '', telefon: '' };
      this.setState({ obj, partnerobj });
    } else {
      obj.partnerid = selectObj.id;
      let telefon = null;
      if (selectObj.telefon && selectObj.telefon.length > 0)
        telefon = selectObj.telefon[0];
      let partnerobj = this.state.partnerobj;
      partnerobj = {
        ...partnerobj,
        szulido: selectObj.szulido ? (new String(selectObj.szulido).replace(/,/g, '.')) : '',
        email: this.dataOrEmptyString(selectObj.email),
        nev: this.dataOrEmptyString(selectObj.nev),
        telefon: this.dataOrEmptyString(telefon)
      };
      this.setState({ obj, partnerobj });
    }
  }

  handleDateInputChange = (name, date) => {
    this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
  }

  handleSzolgaltatasChange = (event, id) => {
    let obj = this.state.obj;
    const szolgaltatas = obj.szolgaltatasselected.find(element => element.id == id);
    obj.idotartam = szolgaltatas.idotartam;
    obj.ar = szolgaltatas.ar;
    this.setState({ obj });
  }

  handlePartnerDateInputChange = (date) => {
    console.log(date);
    let partnerobj = this.state.partnerobj;
    partnerobj.szuletesnap = TimeFormatter.formatDate(new Date(date));
    this.setState({ partnerobj });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({ [name]: value });
  }

  handleTimeChange = (name, date) => {
    if (date) {
      // let minutes = date.getMinutes();
      // let deviation = minutes % 5;
      // if (deviation) {
      //   this.props.globals.addWarning("Az időpont perce csak öttel osztható szám lehet!");
      //   let correction = deviation <= 2 ? deviation : (deviation - 5);
      //   date.setMinutes(minutes - correction);
      // }
      // A kezdet és vege mező el van állítva, majd visszaírva, hogy React re-renderelje a mezőt akkor is, amikor a tárolt érték nem változott a korrigálás után
      // Például ha 13:35-ről 13:36-ra változtat a felhasználó, akkor alapba nem lenne re-render, mert a 13:35-re korrigált érték kerül beírásra,
      // és ez az érték van a változóban eredetileg is, de felületen 13:36 fog látni a felhasználó
      this.setState({ obj: { ...this.state.obj, [name]: new Date() } }, () => {
        this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
      });
    } else {
      this.setState({ obj: { ...this.state.obj, [name]: null } });
    }
  }

  handleKategoriaSelect = (event, value) => {
    this.setState({ kategoriaFilterSelected: value });
  }

  setPartnerobjState = (hozzajarulas) => {
    let partnerobj = hozzajarulas;

    this.setState({ partnerobj });
  }

  pdfSend = () => {
    const { partnerobj } = this.state;
    let partnerNev = (this.emptyOrNull(partnerobj.titulus) ? (partnerobj.titulus + " ") : "") + partnerobj.vezeteknev ? partnerobj.vezeteknev : '' + " " + partnerobj.keresztnev ? partnerobj.keresztnev : '';
    Service.pdfGDPRGenerate(null, partnerNev, partnerobj.jogAlapId, partnerobj.cegadatId, TimeFormatter.formatDate(new Date()) , null, (err, res) => {
      if (!err) {
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/pdf' }), 'hozzajarulas');
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  setOrszaghivo = (value) => {
    this.state.orszagOptions.forEach((item) => {
      if (item.num === value) {
        this.setState({ orszaghivo: item.name.toUpperCase() });
      }
    });
  }

  setTelefonTipus = (value) => {
    this.state.telefonTipusOptions.forEach((item) => {
      if (item.num === value) {
        this.setState({ telefontipus: item.name.toUpperCase() });
      }
    });
  }

  searchPartner = (input, callback) => {
    if (input.length !== 0) {
      Service.getPartnerList(input, (err, res) => {
        if (!err) {
          let newArray = [];
          res[0].forEach((item) => { newArray.push(item); });
          callback(newArray);
        }
      });
    }
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage subtitle="Rögzítsen új időpontot" />;
      case 'TABL':
        return (
          <div style={{ marginTop: -30 }}>
            <NaptarModule
              JSON={this.state.naptarJSON}
              handleSzabadClick={this.handleNaptarChoiceClick}
              handleFoglalasClick={this.handleFoglalasEditClick}
              handleEmptyClick={this.handleNaptarAddClick}
            />
          </div>
        );
      case 'LOAD':
        return <Loader />;
      case 'HIDD':
        return <div />
    }
  }

  render() {
    const {
      teremFilterSelected,
      teremOptions,
      szolgaltatasList,
      szolgaltatasOptions,
      szolgaltatasSelected,
      selectedDay,
    } = this.state;
    const szolgaltatasStateData = {
      elementSelected: szolgaltatasSelected,
      list: szolgaltatasList,
      options: szolgaltatasOptions,
    };
    return (
      <div>
        <RFForm onSubmit={() => this.updateTable(true)}>
          <div className="row">
            <div className="col-auto">
              <DayPickerHu
                selected={this.state.selectedDay}
                onSelect={this.handleDaySelect}
                showOutsideDays
              />
            </div>
            <div className="col-md-3">
              <RFField
                type="select"
                name="teremselect"
                value={teremFilterSelected}
                onChange={this.handleTeremSelect}
                defaultSelect={<option value="" disabled>Válassz termet...</option>}
                selectOptions={teremOptions}
              />
            </div>
            <div className="col">
            <div className="row">
                <div className="col-auto">
                  <ProgressButton className="pull-left table-new-button" color="primary" id="search" loading={this.state.lekerdezesButtonLoading} onClick={() => this.updateTable(true)} disabled={!selectedDay || !teremFilterSelected} >Lekérdezés</ProgressButton>
                </div>
                {this.hasRoleKarb() && (
                  <>
                    <div className="col-auto">
                      <Button className="pull-left table-new-button" color="primary" onClick={this.handleNaptarAddClick} disabled={!selectedDay || !teremFilterSelected}>Új intervallum</Button>
                    </div>
                    {teremFilterSelected  && (
                      <div className="col-auto">
                        <Button className="pull-left table-new-button" color="primary" onClick={this.handleNapMasolasClick} disabled={!selectedDay || !teremFilterSelected}>Nap másolása</Button>
                      </div>
                    )}
                  </>
                )}
                <div className="col-auto">
                  <div style={{ marginTop: 8, marginLeft: 3 }}>
                    <label for="foglalasnelkul">
                      <input id="foglalasnelkul" type="checkbox" style={{ marginRight: 7, marginBottom: 5, verticalAlign: 'middle' }} onClick={this.toggleFoglalasCheckbox} />
                      Foglalás nélkül
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div style={{ marginTop: -8, marginLeft: 3 }}>
            <label for="foglalasnelkul">
              <input id="foglalasnelkul" type="checkbox" style={{ marginRight: 7, marginBottom: 5, verticalAlign: 'middle' }} onClick={this.toggleFoglalasCheckbox} />
              Foglalás nélkül
            </label>
          </div> */}
        </RFForm>
        {this.renderState()}
        <Modal isOpen={this.state.modalMasolas} toggle={this.toggleMasolas} className={this.props.className} backdrop="static">
          <RFForm onSubmit={this.copyDay}>
            <ModalHeader>Nap másolása</ModalHeader>
            <ModalBody>
              <div>
                <DatePicker
                  label="Forrás nap: *"
                  id="copysource"
                  name="copysource"
                  value={this.state.copySource && new Date(this.state.copySource)}
                  onChange={(e, date) => this.setState({ copySource: new Date(date) })}
                />
              </div>
              <Label>Cél nap(ok): *</Label>
              <DayPickerHu
                selected={this.state.selectedDays}
                onSelect={this.handleMasolasDaySelect}
                showOutsideDays
              />
            </ModalBody>
            <ModalFooter>
              {/* <Button color="primary" onClick={this.copyDay}>Másolás</Button> */}
              <ProgressButton loading={this.state.saveButtonLoading} color="primary" type='submit'>Másolás</ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleMasolas}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
        <ModalNaptar
          addNaptar={this.addNaptar}
          className={this.props.className}
          editNaptar={this.editNaptar}
          handleDateInputChange={this.handleDateInputChange}
          handleSzolgaltatasSetState={this.handleSzolgaltatasSetState}
          handleTeremSelect={this.handleTeremSelect}
          handleTimeChange={this.handleTimeChange}
          isOpen={this.state.modalNaptar}
          loadSzolgaltatasElement={this.loadSzolgaltatasElement}
          state={this.state}
          szolgaltatasStateData={szolgaltatasStateData}
          toggle={this.toggleNaptar}
          toggleIsmetlodesCheck={this.toggleIsmetlodesCheck}
          updateIsmetlodesOption={this.updateIsmetlodesOption}
          updateSzolgaltatasOptions={this.updateSzolgaltatasOptions}
          saveButtonLoading={this.state.saveButtonLoading}
        />
        <ModalNaptarDelete
          className={this.props.className}
          isOpen={this.state.modalNaptarTorles}
          onOKClick={this.deleteNaptar}
          state={this.state}
          toggle={this.toggleNaptarTorles}
          deleteButtonLoading={this.state.deleteButtonLoading}
        />
        <ModalNaptarChoice
          addFoglalas={this.handleFoglalasAddClick}
          className={this.props.className}
          deleteNaptar={this.handleNaptarDeleteClick}
          editNaptar={this.handleNaptarEditClick}
          isOpen={this.state.modalNaptarChoice}
          state={this.state}
          toggle={this.toggleNaptarChoice}
          viewNaptar={this.handleNaptarViewClick}
        />
        <ModalNaptarView
          className={this.props.className}
          isOpen={this.state.modalNaptarView}
          state={this.state}
          toggle={this.toggleNaptarView}
        />
        <ModalFoglalas
          className={this.props.className}
          handleDateInputChange={this.handleDateInputChange}
          handleSzolgaltatasChange={this.handleSzolgaltatasChange}
          handlePartnerChange={this.handlePartnerChange}
          handlePartnerModalClick={this.handlePartnerModalClick}
          handleTimeChange={this.handleTimeChange}
          handleKategoriaSelect={this.handleKategoriaSelect}
          isOpen={this.state.modalFoglalas}
          isOpenDelete={this.state.modalFoglalasDelete}
          toggleDelete={this.toggleFoglalasDelete}
          addFoglalas={this.addFoglalas}
          editFoglalas={this.editFoglalas}
          deleteFoglalas={this.deleteFoglalas}
          searchPartner={this.searchPartner}
          state={this.state}
          setState={this.handleForgalomSetState}
          toggle={this.toggleFoglalas}
          helyszinId={this.state.helyszinId}
          saveButtonLoading={this.state.saveButtonLoading}
          deleteButtonLoading={this.state.deleteButtonLoading}
        />
        <ModalPartner
          className={this.props.className}
          handlePartnerDateInputChange={this.handlePartnerDateInputChange}
          handleSelectInputChange={this.handleSelectInputChange}
          isOpen={this.state.modalPartner}
          onOKClick={this.addPartner}
          partnercsoportOptions={this.state.partnercsoportOptions}
          setOrszaghivo={this.setOrszaghivo}
          setTelefonTipus={this.setTelefonTipus}
          state={this.state}
          toggle={this.togglePartner}
          setState={this.setPartnerobjState}
          pdfSend={this.pdfSend}
          saveButtonLoading={this.state.saveButtonLoading}
        />
      </div>
    );
  }
}

export default Naptar;
